import { Route, RouteProps } from 'react-router-dom';
import { patientRoutes } from './patient';
import { encounterRoutes } from './encounter';
import { frontdeskRoutes } from './frontdesk';
import { referralRoutes } from './referral';
import { settingsRoutes } from './settings';
import { phoneTriageRoutes } from './phoneTriage';

export type AppRoute = Pick<RouteProps, 'path' | 'element' | 'Component'> & {
  key?: string;
};

export type AppNavMenu = {
  path: string;
  title: string;
  icon: React.ReactNode;
  submenu?: {
    path: string;
    title: string;
    icon: React.ReactNode;
  }[];
};

export const routes = ({
  isPatientsModuleEntitled,
  isReferralsModuleEntitled,
  isFrontdeskModuleEntitled,
  isPhoneTriageModuleEntitled,
  isTagModuleEntitled,
}: {
  isPatientsModuleEntitled: boolean;
  isReferralsModuleEntitled: boolean;
  isFrontdeskModuleEntitled: boolean;
  isPhoneTriageModuleEntitled: boolean;
  isTagModuleEntitled: boolean;
}) =>
  [
    ...(isPatientsModuleEntitled ? patientRoutes : []),
    ...encounterRoutes,
    ...(isReferralsModuleEntitled ? referralRoutes : []),
    ...(isTagModuleEntitled ? settingsRoutes : []),
    ...(isFrontdeskModuleEntitled ? frontdeskRoutes : []),
    ...(isPhoneTriageModuleEntitled ? phoneTriageRoutes : []),
  ].map((route) => (
    <Route
      key={route.key || route.path}
      path={route.path}
      element={route.element}
    />
  ));

export { patientNavMenus } from './patient';
export { frontdeskNavMenus } from './frontdesk';
export { referralNavMenus } from './referral';
export { settingsNavMenus } from './settings';
export { phoneTriageNavMenus } from './phoneTriage';
